import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import {
  CommunityClubExistenceGQL,
  GymExistenceGQL,
} from '@graphql/generated/graphql';
import { forkJoin, map } from 'rxjs';

export const gymRequiredGuard: CanActivateFn = () => {
  const router = inject(Router);
  const gymExistenceGQL = inject(GymExistenceGQL);
  const communityClubExistenceGQL = inject(CommunityClubExistenceGQL);

  return forkJoin([
    gymExistenceGQL.fetch(),
    communityClubExistenceGQL.fetch(),
  ]).pipe(
    map(([gymsResult, clubsResult]) => {
      const hasGyms = (gymsResult.data.gyms?.length ?? 0) > 0;
      const hasCommunityClubs =
        (clubsResult.data.communityClubs?.length ?? 0) > 0;
      if (!hasGyms && hasCommunityClubs) {
        return router.createUrlTree(['/community-management/community-events']);
      }
      return true;
    })
  );
};
